import { render } from "./ModalBackButton.vue?vue&type=template&id=48f9c07d&lang=pug"
import script from "./ModalBackButton.vue?vue&type=script&lang=js"
export * from "./ModalBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__